var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-main",attrs:{"id":"main"}},[_c('router-view'),_c('a',{staticClass:"bottom_a",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("苏ICP备2021049748号-2")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }